module.exports = __webpack_public_path__ + "img/logo-footer-main.3700eabe.png";